import {Component, OnDestroy, OnInit} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {AuthService} from '../../../../service/auth.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-sign-in-form',
  templateUrl: './sign-in-form.component.html',
  styleUrls: ['./sign-in-form.component.scss']
})
export class SignInFormComponent implements OnInit, OnDestroy {
  form: FormGroup;
  loading: boolean;
  error: string;
  showPassword: boolean;

  private subscriptions: Subscription[] = [];

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl(null),
      password: new FormControl(null)
    });
    this.subscriptions.push(
      this.authService.newPasswordRequired.subscribe(_ =>
        this.error = 'SIGN_IN.CONNECT_TO_IOT'
      )
    );
  }

  signIn() {
    this.error = null;
    this.loading = true;
    this.authService.signIn(this.form.get('email').value, this.form.get('password').value)
      .catch(err => {
        console.error(err);
        this.error = 'SIGN_IN.FAILED';
      })
      .finally(() => this.loading = false);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onChangeEmail($event: any) {
    this.form.get('email').setValue($event.target.value.toLowerCase());
  }
}
